import request from './index.js';

export function login(data) {
    return request.post('/auth/login', data);
}

// 获取图形验证码（4 位数字 SVG）
export function getCaptcha() {
    return request.get('/auth/captcha');
}

export function logout() {
    return request.post('/auth/logout');
}

export function getMe() {
    return request.get('/auth/me');
}

export function updateProfile(data) {
    return request.put('/auth/profile', data);
}

// 保存个人偏好（AI 平台/知识库开关/生成参数，存数据库跟随账号）
export function updatePreferences(data) {
    return request.put('/auth/preferences', data);
}

export function changePassword(data) {
    return request.post('/auth/change-password', data);
}

// 上传头像（multipart）
export function uploadAvatar(file) {
    const formData = new FormData();
    formData.append('file', file);
    return request.post('/upload/avatar', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
}

// 上传平台 Logo（multipart）
export function uploadLogo(file) {
    const formData = new FormData();
    formData.append('file', file);
    return request.post('/upload/logo', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
}

export function refreshToken() {
    return request.post('/auth/refresh');
}
